import { Button, Input, message, Space, Table, Modal, Tag, Dropdown, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import { ExclamationCircleFilled, DownOutlined } from '@ant-design/icons';
import ProductEdit from "./SingleProductEdit";
import ProductAddition from "./SingleProductAddition";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import ESearch, { IMoreConfig, ISearchConfig } from "../../../components/esearch/ESearch";
const { confirm } = Modal;

const Product = () => {
    const [searchValue, setSearchValue] = useState('');
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState<any>({ pageIndex: 1, pageSize: 50 });
    const [dataSource, setDataSource] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenAddition, setIsOpenAddition] = useState(false);
    const [editRecord, setEditRecord] = useState<any>({});
    const [scrollY, setScrollY] = useState("");
    const resize = () => setScrollY(EUtils.getTableScroll(82, ''))
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    const columns: any[] = [
        {
            key: 'productName', title: '产品名称', dataIndex: 'productName'
            , fixed: 'left', ellipsis: true, width: 220,
            render: (text: any, record: any) => <a onClick={() => {
                setEditRecord({
                    viewMode: 1,
                    productID: record.productID
                });
                setIsOpen(true)
            }}>{text}</a>
        },
        { key: 'vendorName', title: '供应商', dataIndex: 'vendorName', width: 120 },
        {
            title: '启用状态', dataIndex: 'isActive', width: 80,
            render: (text: any) => {
                return text ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
            }
        },
        {
            title: '上线状态', dataIndex: 'isOnline', width: 80,
            render: (text: any) => {
                return text ? <Tag color="green">上线</Tag> : <Tag color="red">下线</Tag>
            }
        }, {
            title: '热门推荐', dataIndex: 'isHot', width: 80,
            render: (text: any) => {
                return text ? <Tag color="green">是</Tag> : <Tag color="red">否</Tag>
            }
        },
        { key: 'companyName', title: '保险公司', dataIndex: 'companyName', width: 120 },
        { key: 'scope', title: '保险范围', dataIndex: 'scope', width: 100 },
        { key: 'productType', title: '产品类型', dataIndex: 'productType', width: 100 },
        { key: 'type', title: '险种类型', dataIndex: 'type', width: 100 },
        { key: 'rate', title: '费率', dataIndex: 'rate', width: 100 },
        { key: 'minAmount', title: '底价', dataIndex: 'minAmount', width: 100 },
        { key: 'limitsAmount', title: '限额', dataIndex: 'limitsAmount', width: 80 },
        { key: 'vendorProductID', title: '供应商产品ID', dataIndex: 'vendorProductID', width: 80 },
        { title: '备注', dataIndex: 'remark', width: 150 },
        {
            title: '操作', align: 'center', width: 60, ellipsis: true, fixed: 'right',
            render(value: any, record: any, index: any) {
                var configs: IButtonConfig[] = [
                    {
                        name: '投保申明', onClick: () => { onclickRow(record, 0); },
                    },
                    {
                        name: '投保须知', onClick: () => { onclickRow(record, 1); },
                    },
                    {
                        name: '保险条款', onClick: () => { onclickRow(record, 2); },
                    },
                    {
                        name: '编辑', onClick: () => {
                            setEditRecord({
                                viewMode: 1,
                                productID: record.productID
                            });
                            setIsOpen(true);
                        },
                        hidden: record.isOnline
                    },
                    {
                        name: '删除', onClick: () => { showDeleteConfirm(record); }, danger: true,
                        hidden: record.isOnline
                    },
                    { name: '启用', onClick: () => { showActiveConfirm(record); }, hidden: record.isActive },
                    { name: '禁用', onClick: () => { showActiveConfirm(record); }, hidden: !record.isActive, danger: true },
                ];
                return EUtils.InitButtons(configs);
            }
        }];

    const onclickRow = (record: any, item: any) => {
        var type = 0;
        var title = '投保申明'
        switch (item.key) {
            case '0':
                type = 0;
                title = '投保申明'
                break;
            case '1':
                type = 1;
                title = '投保须知'
                break;
            case '2':
                type = 2;
                title = '保险条款'
                break;
        }
        setEditRecord({
            type: type,
            title: title + '[' + record.productName + ']',
            productID: record.productID
        })
        setIsOpenAddition(true)
    };

    const showDeleteConfirm = (record: any) => {
        confirm({
            title: '删除产品',
            icon: <ExclamationCircleFilled />,
            content: '产品名称[' + record.productName + ']，确认要删除，一旦删除将不能恢复，请慎重操作',
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = { productID: record.productID }
                Server.Post(URL.Product.DeleteProduct, param).then((response: any) => {
                    if (response.isSuccess) {
                        loadData();
                        message.success('删除成功!');
                    }
                })
            },
            onCancel() {
            },
        });
    };
    const showActiveConfirm = (record: any) => {
        confirm({
            title: record.isActive ? '禁用保险产品' : '启用保险产品',
            icon: <ExclamationCircleFilled />,
            content: '保险产品[' + record.productName + ']，确认要'
                + (record.isActive ? '禁用' : '启用')
                + (record.isActive ? '。禁用保险产品同时将下线已上线的保险产品,请慎重！' : ''),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = {
                    productID: record.productID,
                    isActive: !record.isActive
                }
                Server.Post(URL.Product.SetActiveProduct, param).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isActive ? '禁用' : '启用') + '成功!');
                        loadData();
                    } else {
                        message.warn(response.returnMsg);
                    }
                })
            },
            onCancel() {
            },
        });
    };

    useEffect(() => {
        loadData();
    }, [])

    const loadData = () => {
        var params = {
            ...page,
            options: refESearch.current?.getOptions()
        };
        Server.Post(URL.Product.GetProductList, params).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
                setTotal(response.total);
            }
        });
    }

    const refESearch = useRef<any>(null);
    const searchConfig: ISearchConfig[] = [
        { filedID: 'ProductName', filedName: '保险产品' },
        { filedID: 'VendorName', filedName: '供应商' },
        { filedID: 'CompanyName', filedName: '保险公司' },
        { filedID: 'Scope', filedName: '保险范围' },
        { filedID: 'ProductType', filedName: '产品类型' },
        { filedID: 'Type', filedName: '险种类型' },
        { filedID: 'Remark', filedName: '备注' },
    ];
    const moreConfig: IMoreConfig[] = [
        { type: 'select', title: '保险公司', filedID: 'CompanyID', dataUrl: URL.Company.GetCompanyOptions },
        { type: 'select', title: '保险范围', filedID: 'ScopeEnum', dataUrl: URL.Product.GetScopeOptions },
        { type: 'select', title: '产品类型', filedID: 'ProductTypeEnum', dataUrl: URL.Product.GetProductTypeOptions },
        { type: 'select', title: '保险险种', filedID: 'TypeEnum', dataUrl: URL.Product.GetTypeOptions },
        { type: 'select', title: '供应商', filedID: 'VendorID', dataUrl: URL.Vendor.GetVendorOptions },
        { type: 'select', filedID: 'isActive', title: '启用状态', data: [{ value: true, label: '启用' },{ value: false, label: '禁用' }] },
        { type: 'select', filedID: 'isOnline', title: '上线状态', data: [{ value: true, label: '上线' },{ value: false, label: '下线' }] },
        { type: 'select', filedID: 'isHot', title: '热门推荐', data: [{ value: true, label: '是' },{ value: false, label: '否' }, ] },
    ];

    return <div>
        <ESearch searchConfig={searchConfig} moreConfig={moreConfig} onLoad={loadData} resize={resize} ref={refESearch} />
        <div>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', height: '45px', padding: '5px' }}>
                <span style={{ lineHeight: '30px', margin: '5px', fontWeight: 'bold' }}></span>
                <Space style={{ float: 'right' }}>
                    <Button type="primary" onClick={() => {
                        setEditRecord({
                            viewMode: 0,
                            vendorID: null
                        });
                        setIsOpen(true)
                    }}>新增</Button>
                </Space>
            </div>
            <Table size="small" bordered
                scroll={dataSource.length > 0 ? { x: 'max-content', y: scrollY } : { x: 'max-content' }}
                columns={columns} dataSource={dataSource} pagination={{
                    position: ['bottomRight'],
                    style: { margin: '5px' },
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: total,
                    showTotal: ((total) => {
                        return "共" + total + "条";
                    }),
                    current: page.pageIndex,
                    defaultCurrent: 20,
                    pageSize: page.pageSize,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    onShowSizeChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    }),
                    onChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    })
                }}
                summary={(pageData) => {
                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={1} >
                                <Typography.Text>合计:{dataSource.length}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={13} align={'center'}>
                                <Typography.Text></Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={2} align={'center'}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
        <ProductEdit isOpen={isOpen} setIsOpen={() => setIsOpen(false)} loadData={loadData} {...editRecord} />
        <ProductAddition isOpen={isOpenAddition} setIsOpen={() => setIsOpenAddition(false)} {...editRecord} />
    </div>
}
export default Product;